import React, { ReactElement } from 'react';
import Skeleton from 'react-loading-skeleton';
import { BEM } from '@feedfm/feed-util';

import 'react-loading-skeleton/dist/skeleton.css';
import './SidebarPageTemplate.scss';

export interface SidebarPageTemplateProps {
  className?: string;

  /** If true, renders loading skeleton for main and sidebar. */
  loading?: boolean;

  /** Rendering for the title template slot */
  title?: null | ReactElement;
  /** Rendering for the main template slot */
  main?: null | ReactElement;
  /** Rendering for the sidebar template slot */
  sidebar?: null | ReactElement;

  /**
   * If true, sidebar is hidden, and both `props.sidebar` and `props.widebarSidebar` are ignored.
   */
  hideSidebar?: boolean;
  /** If true, show the wider form sidebar. */
  widebarSidebar?: boolean;
}

const bem = new BEM( 'sidebar-page-template' );

export const SidebarPageTemplate = ( props: SidebarPageTemplateProps ): ReactElement => {
  const { className, loading, main, sidebar, title, hideSidebar = false, widebarSidebar = false } = props;

  const modifiers = {
    loading,
    narrow: !hideSidebar && !widebarSidebar,
    wide: !hideSidebar && widebarSidebar,
  };

  return (
    <div className={ BEM.$( className, bem.mod( modifiers ) ) }>
      <section className={ BEM.$( bem.el( 'main' ) ) }>
        { title && <section className={ BEM.$( bem.el( 'title' ) ) }>{ title }</section> }
        { loading && <Skeleton height="100%" containerClassName="flex-1" /> }
        { !loading && main }
      </section>
      { hideSidebar !== true && (
        <aside className={ BEM.$( bem.el( 'sidebar' ) ) }>
          { loading && <Skeleton height="100%" containerClassName="flex-1" /> }
          { !loading && sidebar }
        </aside>
      ) }
    </div>
  );
};
